import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { userLogout } from '../actions/user';

import { UserAvatar } from '../components/header';

const mapState = state => ({
  profile: state.user.profile
});

const mapDispatch = {
  userLogout
};

export default withRouter(
  connect(
    mapState,
    mapDispatch
  )(UserAvatar)
);
